import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-responsive-modal-wrapper',
  templateUrl: './responsive-modal-wrapper.component.html',
  styleUrls: ['./responsive-modal-wrapper.component.scss'],
})
export class ResponsiveModalWrapperComponent implements OnInit {
  @Input() height = '500px';
  @Input() width = '500px';
  @Output() close = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  closeClick(e: MouseEvent) {
    e.stopPropagation();
    this.close.emit();
  }
}
